const React = require('react');
const queryString = require('query-string');
const Location = require('@reach/router').Location;
const slugToTitleCaseES5 = require('./src/utils/es5helpers').slugToTitleCaseES5;
const { UTM_DEFAULT_DIRECT, UTM_DEFAULT_SEO } = require('./src/utils/const.js');
const { sentryWarning, sentryError } = require('./src/utils/sentryHelpers');
require('whatwg-fetch');

exports.onClientEntry = () => {
  // set up PM environment variable
  let pm_env;
  if (process.env.GATSBY_PM_ENV) {
    pm_env = process.env.GATSBY_PM_ENV;
  } else {
    pm_env = 'dev';
  }
};

// HOC providing the current route (location), tools for programmatic
// navigation, and the query string parsed into an object (search)
// const withLocation = ComponentToWrap => props => (
//   <Location>
//     {({ location, navigate }) => {
//       return <ComponentToWrap
//         {...props}
//         location={location}
//         navigate={navigate}
//         query={location.search ? queryString.parse(location.search) : {}}
//       />;
//     }}
//   </Location>
// );
